import { Injectable } from '@angular/core';
import moment from 'moment';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly Style = {
    log: ['color: black', 'background-color: #efefef', 'padding: 4px 8px', 'border-radius: 5px'].join(';'),
    info: ['color: white', 'background-color: blue', 'padding: 4px 8px', 'border-radius: 5px'].join(';'),
    debug: ['color: white', 'background-color: orange', 'padding: 4px 8px', 'border-radius: 5px'].join(';'),
    warn: ['color: black', 'background-color: yellow', 'padding: 4px 8px', 'border-radius: 5px'].join(';'),
    error: ['color: white', 'background-color: red', 'padding: 4px 8px', 'border-radius: 5px'].join(';'),
  };
  name!: string;

  setName(name: string): void {
    this.name = name;
  }

  log(message: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.log(this.logPrefix, this.Style.log, message);
    }
  }

  info(message: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.info(this.logPrefix, this.Style.info, message);
    }
  }

  debug(message: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.debug(this.logPrefix, this.Style.debug, message);
    }
  }

  warn(message: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.warn(this.logPrefix, this.Style.warn, message);
    }
  }

  error(message: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.error(this.logPrefix, this.Style.error, message);
    }
  }

  clear() {
    console.clear();
  }

  private get logPrefix(): string {
    return `%c${moment.utc().toISOString()} [${this.name}]`;
  }
}
